// extracted by mini-css-extract-plugin
export default {"container":"Kelly_container__qqHYQ","mimo":"Kelly_mimo__KML9A","textBox":"Kelly_textBox__T79yX","textList":"Kelly_textList__Zvomx"};